import { Component, OnInit, HostListener, Inject, EventEmitter, Output } from '@angular/core';
import { KeyValue, DOCUMENT } from '@angular/common';
import { trigger, state, transition, style, animate } from '@angular/animations';
import { Subscription } from 'rxjs';

import { HeaderService } from '../Services/header.service';

@Component({
  selector: 'app-breadcrumb',
  templateUrl: './breadcrumb.component.html',
  styleUrls: ['../app.component.scss'],
  animations: [
    trigger('fade',
      [
        state('void', style({ opacity: 0 })),
        transition(':enter', [animate(300)]),
        transition(':leave', [animate(500)]),
      ]
    )]
})
export class BreadcrumbComponent implements OnInit {

  breadcrumbSub: Subscription;
  constructor(private headerService: HeaderService, @Inject(DOCUMENT) document) { }

  breadcrumbs: KeyValue<string, string>[] = [];
  admin = false;

  set filterItem(value: string) {
    this.headerService.emitFilterTerm(value.trim());
  }

  get searchItem() {
    return this.headerService.searchTerm;
  }
  set searchItem(value: string) {
    this.headerService.clearAlerts();
    this.headerService.searchTerm = value.trim();
  }

  onSearch(event) {
    if (event && event.length < 3) {
      this.headerService.pushAlerts('danger',
        `Search values must be longer than 2 characters`);
    } else {
      this.headerService.emitSearchCommand();
    }
  }

  ngOnInit(): void {
    this.breadcrumbSub = this.headerService.breadcrumb$.subscribe(
      bc => {
        this.setupBreadcrumbs(bc);
      });
  }

  setupBreadcrumbs(bc: object) {
    this.breadcrumbs = [];
    let viewRoute = 'applications';
    const adminRoute = 'administration';

    const app = 'appName';
    const ID = 'appId';
    const mo = 'month';

    this.admin = bc["admin"];

    this.breadcrumbs.push({ key: viewRoute, value: 'App Dashboard' });
    if (bc[app]) { this.breadcrumbs.push({ key: viewRoute += '/' + bc[app] + '/' + bc[ID], value: bc[app] }); }
    if (bc[mo]) { this.breadcrumbs.push({ key: viewRoute += '/' + bc[mo], value: 'Release Notes' }); }

    if (!this.admin) {
      this.breadcrumbs[this.breadcrumbs.length - 1].key = 'active';
    }
  }

  @HostListener('window:scroll', ['$event'])
  onWindowScroll(e) {
    if (window.pageYOffset > 244) {
      const element = document.getElementById('navbar');
      if (element) { element.classList.add('sticky'); }
    } else {
      const element = document.getElementById('navbar');
      if (element) { element.classList.remove('sticky'); }
    }
  }

}
